import React, { useContext } from "react";
import { LanguageContext } from "MainApp/assets/utils/context/LanguageContext";
import { IsRotatedContext } from "MainApp/assets/utils/context/isRotatedContext";
import {
  LANGUAGE_OPTIONS,
  getSupportedLanguageCode,
} from "MainApp/assets/utils/js/localeUtils";
import "./LanguageSelector.css";

const LanguageSelector = ({ className, isPhone }) => {
  const { language, setLanguage } = useContext(LanguageContext);
  const { isRotated } = useContext(IsRotatedContext);

  const handleChange = (event) => {
    setLanguage(event.target.value);
  };

  return (
    <select
      name="language"
      className={className ? className : "languageSelector"}
      onChange={handleChange}
      value={getSupportedLanguageCode(language)}
      style={{ padding: isPhone ? (isRotated ? "" : "") : 4 }}
    >
      {LANGUAGE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelector;
